// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4X5Ke","controls":"styles_controls__2Gmnt","charLimit":"styles_charLimit__27fw2","input":"styles_input__ld4kO","send":"styles_send__11i4C"};